
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  API_URL: '/api/',
  // API_URL: 'http://alpha.inventiveiq.net/api/',
  // API_URL: 'http://49.143.252.27:3005/api/',
  // API_URL: 'http://49.143.252.27:27022/api/',
  //API_URL: 'http://192.168.0.11:3002/api/',
  //API_URL: 'http://192.168.0.11:3001/api/',
  //API_URL: 'http://10.0.0.7:3001/api/',
  //API_URL: 'http://122.170.105.97:3001/api/',
  //API_URL: 'http://crm.visionsmartlink.com/api/',
  //SOCKET_SERVER_URL: '',
  SOCKET_SERVER_URL: 'https://partner.myslbb.com/',
  //SOCKET_SERVER_URL: 'https://crm.visionsmartlink.com:8000'
  //SOCKET_SERVER_URL: 'http://10.0.0.7:8080'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
